<template>
  <area-component
    :ad="Array.isArray(ad) ? {} : ad"
    :showSkeleton="showSkeleton"
    v-model="isLoading"
    @onRefresh="onRefresh"
    @loadData="loadData"
    :show-loading="showLoading"
    :errorImg="require(`@/assets/img/home/special_banner.jpg`)"
    ref="areaComponent"
    title="今日特价">
    <div class="goods">
      <ul :class="['goods-tab',ad&&ad.background_color&&ad.background_color!='FFFFFF' ? '':'tabColor']">
        <li @click="changeTab(0)" :class="{active:type===0}">进行中</li>
        <li @click="changeTab(1)" :class="{active:type===1}">下期预告</li>
      </ul>
      <not-goods v-if="list.length === 0"></not-goods>
      <div class="goods-list">
         <goods-item
           v-for="item in list"
           :item="item"
           :key="item.goods_id"
           @click.native="toDetail(item)"
           :stockTag="getShowStock (item)"
         >
           <template slot="time">
             {{type === 1?'距开始':'距结束' }}:<span>{{item.countDown.d}}</span>天<span>{{item.countDown.h}}</span>时<span>{{item.countDown.m}}</span>分<span>{{item.countDown.s}}</span>秒
           </template>
           <template slot="btn">
             <goods-btn
               :btn-type="getGoodsType(item)"
               @openCart="openCart(item)"
             />
           </template>
         </goods-item>
      </div>
    </div>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        getContainer="body"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        getContainer="body"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
  </area-component>
</template>

<script>
import Vue from 'vue'
import AreaComponent from '../components/area-component'
import GoodsItem from '../components/item-component'
import { Toast } from 'vant'
import { requestSpeciallist } from '../../../fetch/home/special'
import NotGoods from '../components/not-goods'
import GoodsBtn from '../components/btn'
import CommandMinxin from '@/mixins/command'
import CartStepMinxin from '@/mixins/cartStep'
import CountDownMixin from '@/mixins/countDown'

Vue.use(Toast)
// Toast.allowMultiple()
let toast = null
export default {
  name: 'special',
  mixins: [CommandMinxin, CartStepMinxin, CountDownMixin],
  components: { GoodsBtn, NotGoods, AreaComponent, GoodsItem },
  data () {
    return {
      pageArr: [1, 1],
      ad: null,
      showLoading: true,
      type: 0,
      isLoading: false,
      isShowSmallNav: false,
      showSearch: false,
      list: [],
      showSkeleton: true,
      newList: []
    }
  },
  computed: {
    areaComponent () {
      return this.$refs.areaComponent
    },
    getShowStock () {
      return function (item) {
        if (this.getLoginStatus.data.member_id) {
          // 登录
          if (item.stock * 1 === 0 || +item.min_stock <= 0) {
            return 3
          } else if (item.goodsstock * 1 <= 0) {
            return 2
          } else {
            return 1
          }
        } else {
          return 1
        }
      }
    }
  },
  activated () {
    this.$nextTick(() => {
      this.loadData()
    })
  },
  methods: {
    toDetail (item) {
      this.$router.push({
        path: '/goods-details',
        query: {
          goods_id: item.goods_id,
          type: item.for_type
        }
      })
    },
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) { // 登录
        if (this.type === 0) {
          if (item.is_view === 1) { // 区域经销
            return 1
          }
          if (item.stock * 1 === 0 || +item.min_stock <= 0) { // 无特价库存
            return 3
          }
          if (item.goodsstock * 1 <= 0) { // 无商品库存
            return 4
          }
          return 2
        } else {
          return 5
        }
      } else {
        return 0
      }
    },
    judgeTime (item) {
      if (this.type === 0) {
        return parseInt(+item.end_date - +item.now_time)
      } else {
        return parseInt(+item.start_date - +item.now_time)
      }
    },
    changeTab (type) {
      this.type = type
      this.areaComponent.m_finishedText = ''
      this.showLoading = false
      this.areaComponent.mReset()
      toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner'
      })
      this.loadData(true)
    },
    openCart (item) {
      this.cartBtnAlter(item, this.cartIconColorno0(item) ? 1 : 0)
    },
    onRefresh () {
      this.areaComponent.mReset()
      this.showLoading = false
      this.loadData(true)
    },
    async loadData (reset) {
      this.areaComponent.mRequest()
      const params = {
        type: this.type,
        page: this.areaComponent.m_page.curr,
        limit: 10
      }
      const res = await requestSpeciallist(params)
      this.$tips(res, {
        tip: false
      }, res => {
        if (this.showSkeleton) {
          this.showSkeleton = false
        }
        this.isLoading = false
        this.showLoading = true
        const data = res
        this.ad = data.ad
        if (toast) {
          toast.clear()
        }
        // this.ad = data.ad
        if (data.sprcial_goods_arr.length === 0) {
          this.areaComponent.mEnd('--我也是有底线的--')

          if (reset) {
            this.list = []
          }
          if (this.list.length === 0) {
            this.areaComponent.m_finishedText = ''
          }
        } else {
          this.newList = data.sprcial_goods_arr
          this.newList.forEach(item => {
            this.$set(item, 'countDown', {
              d: '',
              h: '',
              m: '',
              s: ''
            })
            this.countDown(item)
          })
          this.addGoodField(this.newList)
          if (reset) {
            this.list = this.newList
          } else {
            this.list.push(...this.newList)
          }
        }
        this.areaComponent.mSuccess()
      })
    },
    openSearch () {
      this.showSearch = true
      this.isShowSmallNav = false
    }

  }
}
</script>

<style scoped lang="scss">
.goods{
  width: 100%;
  &-tab{
    width:40%;
    margin: 0 auto 10px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #f1f1f1;
    .active{
      color:#FFFFFF;
      position: relative;
      &:before{
        content: '';
        display: inline-block;
        width: 40px;
        height: 1PX;
        background: #ffffff;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: -2px;
      }
    }
  }
  .tabColor{
    color: #333333;
    .active{
      color:#000000!important;
      position: relative;
      &:before{
        content: '';
        display: inline-block;
        width: 40px;
        height: 1PX;
        background: #000000;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: -2px;
      }
    }
  }
  &-list{
    width: 355px;
    &-item{
      width: 355px;
      height: 171px;
      border-radius: 10px;
      background: #ffffff;
      display: flex;
      flex-direction: column;
      .top{
        height: 35px;
        padding: 0 10px;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span{
          width: 15px;
          height: 15px;
          border:1px solid rgba(229,229,229,1);
          display: inline-flex;
          justify-content: center;
          align-items: center;
          margin: 0 6px;
          border-radius:4px;
        }
      }
      .center{
        flex: 1;
        box-sizing: border-box;
        padding: 16px 16px 0;
        display: flex;
        .img{
          width: 78px;
          height: 78px;
          img{
            width: 100%;
          }
        }
        .info{
          margin-left: 25px;
          flex: 1;
          .name{
            color: #333333;
            font-size: 15px;
            @include ell();
          }
          .company{
            color: #777777;
            font-size: 12px;
          }
          .bottom{
            margin-top: 10px;
            display: flex;
            justify-content:space-between;
            .price{
              font-size: 12px;
              b{
                font-size: 18px;
              }
            }
            .del-price{
              text-decoration: line-through;
              color:#BFBDBD;
              margin-left: 6px;
            }
            .btn{
              @include center();
              color: #ffffff;
              background: var(--APP_theme_color);
              border-radius: 12px;
              width: 65px;
              height: 24px;
            }
          }
        }
      }
      > .bottom{
        height: 30px;
        padding: 0 10px;
        box-sizing: border-box;
        color:#FF5B7A;
        display: flex;
        align-items: center;
      }
      .line{
        height: 1px;
        width: 100%;
        background: rgba(229,229,229,1);
        transform: scaleY(0.5);
      }
    }
  }
}
  .price{
    color: #EA2727;
  }
</style>
